export const optionsBreadcrumb = [
  //REGISTER
  { link: "/register", title: "Εγγραφή" },

  //LOCATIONS
  { link: "/location", title: "Αναζήτηση Τοποθεσιών" },
  { link: "/location/details/:id", title: "" },
  { link: "/location/new", title: "Αίτημα Καταχώρισης Τοποθεσίας" },

  {
    link: "/location/edit",
    title: "Αίτημα Επεξεργασίας Στοιχείων Τοποθεσίας / Ιδιοκτησίας",
  },
  { link: "/location/edit/:id", title: "" },
  {
    link: "/location/request-form",
    title: "Αίτημα Ενδιαφέροντος για Γύρισμα στην Τοποθεσία",
  },
  { link: "/location/request-form/:id", title: "" },
  { link: "/preview", title: "Προεπισκόπηση Αιτήματος" },
  {
    link: "/location/view-interest",
    title: "Αίτημα Ενδιαφέροντος για Γύρισμα στην Τοποθεσία",
  },
  {
    link: "view-interest",
    title: "Αίτημα Ενδιαφέροντος για Γύρισμα στην Τοποθεσία",
  },
  { link: "view-interest/:id", title: "" },
  { link: "/location/view-interest/:id", title: "" },

  { link: "/view", title: "Αίτημα Καταχώρισης Τοποθεσίας" },
  { link: "/view/:id", title: "" },
  {
    link: "/professionals/view",
    title: "Αίτημα Καταχώρισης Επαγγελματία / Επιχείρησης",
  },
  { link: "/professionals/view/:id", title: "" },
  { link: "/applications", title: "Αιτήματα στο ΕΚΟΜΕ" },
  { link: "/my-applications", title: "Τα Αιτήματα μου" },

  { link: "/my-favorites", title: "Αγαπημένα" },
  { link: "/my-registrations", title: "Καταχωρίσεις" },

  //PROFESSIONALS
  { link: "/professionals", title: "Αναζήτηση Επαγγελματιών" },
  {
    link: "/professionals/new",
    title: "Αίτημα Καταχώρισης Επαγγελματία / Επιχείρησης",
  },

  { link: "/professionals/details/:id", title: "" },
  {
    link: "/professionals/edit/:id",
    title: "Αίτημα Επεξεργασίας Στοιχείων Επαγγελματία / Επιχείρησης",
  },

  //PROFILE
  { link: "/profile", title: "Το Προφίλ μου" },
  //OA
  //collections
  { link: "/collections", title: "Συλλογές ΕΚΟΜΕ" },
  { link: "/collections/details/:id", title: "" },

  { link: "/search-collections", title: "Αναζήτηση στις Συλλογές ΕΚΟΜΕ" },
  { link: "/search-collections/details/:id", title: "" },
  //documents
  {
    link: "/search-documents",
    title: "Αναζήτηση στο Υλικό των Οπτικοακουστικών Φορέων",
  },
  { link: "/search-documents/details/:id", title: "" },
  //organisations
  { link: "/search-organisation", title: "Αναζήτηση Οπτικοακουστικών Φορέων" },
  { link: "/search-organisation/details/:id", title: "" },
  //projects
  { link: "/search-projects", title: "Αναζήτηση Οπτικοακουστικών Έργων" },
  { link: "/search-projects/details/:id", title: "" },
];
